import PagesContainer from "../../../../components/UI/PagesContainer";
import { useTranslation } from "react-i18next";
import { Form } from "@4uhub/lib4uhub";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  confirmTopMedScheduleSchema,
  TConfirmTopMedScheduleForm,
} from "./confirmTopMedSchedueSchema";
import { FirstStep } from "./FirstStep/FirstStep";
import { SecondStep } from "./SecondStep/SecondStep";
import { TopMedScheduleContextProvider } from "../../../../store/contexts/TopMedScheduleContext/TopMedScheduleContext";
import { ConfirmTopMedScheduleContainer } from "./ConfirmTopMedScheduleContainer/ConfirmTopMedScheduleContainer";

const translationPath = "page.topmedSchedule.newSchedule.";

const ConfirmTopMedSchedule = () => {
  const { t } = useTranslation();

  const methods = useForm<TConfirmTopMedScheduleForm>({
    resolver: zodResolver(confirmTopMedScheduleSchema),
  });

  return (
    <PagesContainer
      redirectTo={"/schedule-teleconsultation/topmed-schedule"}
      title={t(translationPath + "title")}
      loading={false}
    >
      <Form {...methods}>
        <TopMedScheduleContextProvider>
          <ConfirmTopMedScheduleContainer>
            <FirstStep />
            <SecondStep />
          </ConfirmTopMedScheduleContainer>
        </TopMedScheduleContextProvider>
      </Form>
    </PagesContainer>
  );
};

export default ConfirmTopMedSchedule;
